module.exports = __webpack_public_path__ + "img/check.dd762c80.svg";